import { SIMULACAO_TITULO } from "@/modules/recursos/simulacao";

import type { GanttPrintChromeProps, GanttPrintChromeViewModel } from "./types-gantt-print-chrome";

function splitFilterChip(item: string): { label: string; value: string } {
  const separator = item.indexOf(": ");
  if (separator === -1) return { label: "", value: item };
  return { label: item.slice(0, separator), value: item.slice(separator + 2) };
}

export function useGanttPrintChrome({
  title,
  generatedLabel,
  filters,
  legend,
  simulando = false,
}: GanttPrintChromeProps): GanttPrintChromeViewModel {
  return {
    title,
    generatedLabel,
    notaSimulacao: simulando ? SIMULACAO_TITULO : null,
    chips: filters.map((line) => ({ line, ...splitFilterChip(line) })),
    legend,
    mostraMeta: filters.length > 0 || legend != null,
  };
}
